<template lang="pug">
markup-wrapper.page-text
	.page-text__sub(v-if="$slots.sub")
		slot(name="sub")
	slot
</template>

<script>
import { Wrapper as MarkupWrapper } from '@/components/markup';

export default {
  components: {
    MarkupWrapper,
  },
};
</script>

<style lang="scss" scoped>
.page-text {
  color: #666;
  padding-bottom: 18px;
  line-height: 140%;
  text-align: justify;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;

  & /deep/ h1 {
    margin: 29px 0;
    padding-bottom: 13px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 300;
    font-size: 40px;
    line-height: 100%;
    text-align: left;
    color: rgba(0, 0, 0, 0.85);
    border-bottom: 1px solid #d3d4d9;
    user-select: text;
    width: 100%;

    & + h3 {
      margin-top: -0.6em;
    }
  }

  & /deep/ h2 {
    margin-bottom: 0.7em;
    font-size: 16px;
    line-height: 1.4;
    color: rgba(0, 0, 0, 0.85);
    text-transform: uppercase;
    font-weight: 700;
    text-align: left;
  }

  & /deep/ h3 {
    margin-bottom: 1em;
    font-size: 12px;
    line-height: 1.25;
    color: rgba(0, 0, 0, 0.85);
    text-transform: uppercase;
    font-weight: normal;
    text-align: left;
  }

  & /deep/ p {
    margin-bottom: 1em;
  }

  & /deep/ ul,
  & /deep/ ol {
    margin-left: 2em;
    margin-bottom: 1em;
  }

  & /deep/ img {
    width: 100%;
    height: auto;
    border: 0;
  }

  & /deep/ .text_color_black {
    color: rgba(0, 0, 0, 0.85);
  }

  & /deep/ .link {
    display: inline-block;
    font-weight: 400;
    color: #0090ff;
    border-bottom: 2px solid transparent;
    transition: color 0.3s ease, border-bottom 0.3s ease;
    font-family: 'Open Sans', sans-serif;
    text-decoration: none;

    &:hover {
      text-decoration: none;
      color: #51acff;
      border-bottom: 2px solid #0090ff;
    }
  }

  &__sub {
    text-align: right;
    margin-right: -100px;
  }
}
</style>



// WEBPACK FOOTER //
// Text.vue?d62ff458